import { render, staticRenderFns } from "./cashregister.vue?vue&type=template&id=61314e04&scoped=true"
import script from "./cashregister.vue?vue&type=script&lang=js"
export * from "./cashregister.vue?vue&type=script&lang=js"
import style0 from "./cashregister.vue?vue&type=style&index=0&id=61314e04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61314e04",
  null
  
)

export default component.exports